import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { getRebuildAPI } from "@rebuild/shared/api";
import type { EstimatesControllerArchiveRoomBody } from "@rebuild/shared/generated/models/estimatesControllerArchiveRoomBody";
import { ESTIMATE_KEYS } from "@/hooks/queries/estimates/queryKeys";

const { estimatesControllerArchiveRoom } = getRebuildAPI();

export function useArchiveRoomMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: EstimatesControllerArchiveRoomBody) => {
      return estimatesControllerArchiveRoom(body);
    },
    onError: (error) => {
      toast.error("Failed to archive room");
      console.error("Archive room error:", error);
    },
    onSuccess: (_data, variables) => {
      if (variables.estimateId) {
        queryClient.invalidateQueries({ queryKey: ESTIMATE_KEYS.detail(variables.estimateId) });
      }
      toast.success("Room archived");
    },
  });
}
